export default function Footer() {
    return (
        <footer>
            <p>A registered charity in England (no. 1145841)</p>
        </footer>
    )
}